'use strict'

import actions from './actions'
import getters from './getters.js'
import Vue from 'vue'

const state = {
  // snackbar for create/update/delete events
  snackbarShow: false,
  snackbarMessage: '',
  snackbarColor: '',

  selectedSchipment: null, // which shiment is selected in ShipmentsList (for map view)

  ordersActionStarted: false, // some action for orders started (palletization, moving to shipment, ...)
  // TODO: change selectedPackages from array do dictionary for better performence ???
  selectedPackages: [], // selected packages for action

  algoliaDateFilters: {},

  allSelectedFilters: [],
  selectedCustomFilters: {},

  isOverlayLoading: false,

  drawerMenuOpen: null
}

const mutations = {
  SHOW_SNACKBAR (state, data) {
    state.snackbarShow = true
    state.snackbarMessage = data.message
    state.snackbarColor = data.color
  },
  CLOSE_SNACKBAR (state) {
    state.snackbarShow = false
    state.snackbarMessage = ''
    state.snackbarColor = ''
  },
  SET_SELECTED_SHIPMENT (state, index) {
    if (state.selectedSchipment !== index) {
      state.selectedSchipment = index
    } else {
      state.selectedSchipment = null
    }
  },
  UNSELECT_PACKAGE (state, pckg) {
    state.selectedPackages = state.selectedPackages.filter(ele => {
      return ele.id !== pckg.id
    })
  },
  UNSELECT_ORDER (state, order) {
    state.selectedPackages = state.selectedPackages.filter(ele => {
      return ele.order.order_id !== order.id
    })
  },
  SELECT_PACKAGE (state, pckg) {
    let includes = false
    for (let i = 0; i < state.selectedPackages.length; i++) {
      if (state.selectedPackages[i].id === pckg.id) {
        includes = true
        break
      }
    }
    if (!includes) {
      state.selectedPackages.push(pckg)
    }
  },
  START_ORDERS_ACTION (state) {
    state.selectedPackages = []
    state.ordersActionStarted = true
  },
  END_ORDERS_ACTION (state) {
    state.selectedPackages = []
    state.ordersActionStarted = false
  },
  SET_LOADING (state, loading) {
    state.isOverlayLoading = loading
  },
  SET_DATE_FILTER (state, data) {
    if (data.filter === '') {
      Vue.delete(state.algoliaDateFilters, data.index)
    } else {
      Vue.set(state.algoliaDateFilters, data.index, data.filter)
    }
  },
  SET_ALL_SELECTED_FILTERS (state, data) {
    Vue.set(state, 'allSelectedFilters', data)
  },
  CLEAR_DATE_FILTER (state) {
    Vue.set(state, 'algoliaDateFilters', {})
  },
  SET_DRAWER_MENU (state, value) { // TODO: Probably just temporal thing
    state.drawerMenuOpen = value
  },
  SELECT_CUSTOM_FILTERS (state, data) {
    if (state.selectedCustomFilters[data.attribute] !== undefined && state.selectedCustomFilters[data.attribute] === data.value) {
      Vue.delete(state.selectedCustomFilters, data.attribute)
    } else {
      Vue.set(state.selectedCustomFilters, data.attribute, data.value)
    }

    // if (state.selectedCustomFilters.includes(value)) {
    //   state.selectedCustomFilters = state.selectedCustomFilters.filter(item => {
    //     return item !== value
    //   })
    // } else {
    //   state.selectedCustomFilters.push(value)
    // }
  },
  CLEAR_SELECTED_CUSTOM_FILTERS (state) {
    state.selectedCustomFilters = {}
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
